(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["parse_curl_js"] = factory();
	else
		root["parse_curl_js"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse = parse;
var optionsRegex = /(--[a-zA-Z\-]+ '.*?')|(--[a-zA-Z\-]+)|(-[a-zA-Z\-]+? '.+?')|('?[a-z]+:\/\/.*?'+?)|("?[a-z]+:\/\/.*?"+?)/g; // eslint-disable-line
var urlRegex = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/; // eslint-disable-line

var contentTypeHeader = 'content-type';
var jsonMimeType = 'application/json';

var isMatchingOption = function isMatchingOption(headers, str) {
  for (var i = 0; i < headers.length; i += 1) {
    if (str.startsWith(headers[i])) {
      return true;
    }
  }
  return false;
};

var isAHeaderOption = function isAHeaderOption(str) {
  return isMatchingOption(['-H ', '--headers '], str);
};
var isDataOption = function isDataOption(str) {
  return isMatchingOption(['--data ', '--data-ascii ', '-d ', '--data-raw ', '--dta-urlencode ', '--data-binary '], str);
};

var removeLeadingTrailingQuotes = function removeLeadingTrailingQuotes(str) {
  var quotes = ['\'', '"'];
  var newStr = str.trim();
  return quotes.includes(newStr[0]) ? newStr.substr(1, newStr.length - 2) : newStr;
};

var subStrFrom = function subStrFrom(val, startFromVal) {
  var dataPosition = val.indexOf(startFromVal);
  return val.substr(dataPosition);
};

var isJsonRequest = function isJsonRequest(parsedCommand) {
  return parsedCommand.headers[contentTypeHeader] && parsedCommand.headers[contentTypeHeader].indexOf(jsonMimeType) !== -1;
};

var parseBodyByContentType = function parseBodyByContentType(_ref) {
  var body = _ref.body,
      headers = _ref.headers;

  if (body && isJsonRequest(headers)) {
    try {
      var cleanedBodyData = body.replace('\\"', '"').replace("\\'", "'");
      return JSON.parse(cleanedBodyData);
    } catch (ex) {
      // ignore json conversion error..
      console.log('Cannot parse JSON Data ' + ex.message); // eslint-disable-line
    }
  }
  return body;
};

var parseOptionValue = function parseOptionValue(val) {
  var headerSplit = subStrFrom(val, ' ').split(':');
  return {
    key: headerSplit[0].trim(),
    value: headerSplit[1].trim()
  };
};

var parseQueryStrings = function parseQueryStrings(url) {
  var paramPosition = url.indexOf('?');
  var queryStrings = {};
  if (paramPosition !== -1) {
    // const splitUrl = parsedCommand.url.substr(0, paramPosition);
    var paramsString = url.substr(paramPosition + 1);
    var params = paramsString.split('&') || [];

    params.forEach(function (param) {
      var splitParam = param.split('='); // eslint-disable-line
      queryStrings[splitParam[0]] = splitParam[1]; // eslint-disable-line
    });
  }
  return queryStrings;
};

var parseUrlOption = function parseUrlOption(val) {
  var urlMatches = val.match(urlRegex) || [];
  if (urlMatches.length) {
    var url = urlMatches[0]; // eslint-disable-line
    return {
      url: url,
      queryStrings: parseQueryStrings(url)
    };
  }
  return { url: '', queryStrings: {} };
};

var parseBody = function parseBody(val) {
  return removeLeadingTrailingQuotes(subStrFrom(val, ' '));
};

var isACurlCommand = function isACurlCommand(val) {
  return val.trim().startsWith('curl ');
};
var isAUrlOption = function isAUrlOption(val) {
  var matches = val.match(urlRegex) || [];
  return !!matches.length;
};

/*
 * Parse cUrl command to a JSON structure
 * params:
 * command - cUrl command as a string.
 * return JSON object
*/
function parse(command) {
  if (!command) {
    return '';
  }

  var parsedCommand = {
    url: ''
  };

  // quit if the command does not starts with curl
  if (isACurlCommand(command)) {
    var matches = command.match(optionsRegex);
    matches.forEach(function (val) {
      var option = removeLeadingTrailingQuotes(val);
      if (isAUrlOption(option)) {
        var _parseUrlOption = parseUrlOption(option),
            url = _parseUrlOption.url,
            queryStrings = _parseUrlOption.queryStrings;

        parsedCommand.url = url;
        parsedCommand.queryStrings = queryStrings;
      } else if (isAHeaderOption(option)) {
        var _parseOptionValue = parseOptionValue(option),
            key = _parseOptionValue.key,
            value = _parseOptionValue.value;

        parsedCommand.headers = parsedCommand.headers || {};
        parsedCommand.headers[key] = value;
      } else if (isDataOption(option)) {
        parsedCommand.body = parseBody(option);
      } else {
        console.log('Skipped Header ' + val); // eslint-disable-line
      }
    }); // parse over matches ends

    // should be checked after all the options are analyzed
    // so that we guarentee that we have content-type header
    parsedCommand.body = parseBodyByContentType(parsedCommand);
  }

  return parsedCommand;
}

exports.default = parse;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// parse-curl-js.js